import { urlUtils } from './utils'

export const enum authStates {
  REDIRECTED,
  NON_AUTHENTICATED,
  THIRD_PARTY_AUTHENTICATION,
}

const defineState = (): authStates => {
  // 1.- Verificamos si el token que recibimos es de terceros
  const hasAuth = urlUtils.checkUrlQueryParams(['auth'])
  if (hasAuth) return authStates.THIRD_PARTY_AUTHENTICATION

  // 2.- Sin parametros en la url ni datos guardados en el store
  const hasCode = urlUtils.checkUrlQueryParams(['code'])
  if (hasCode) return authStates.REDIRECTED

  return authStates.NON_AUTHENTICATED
}

export { defineState }
